/* tslint:disable */
var TSingleState = (function () {
    "use strict";
    var api = <any>{};

    // Overrides SingleSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };

    // Template logic splitter
    api.buildOptions = function (selections) {
        return TSingleOptions.buildSingle(this, selections);
    };

    api.buildSelectionInnerView = function (__html, selection, selectionUpdated) {
        __html.push(TBuildLine.buildView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true }));
    };

    return api;
}());

window.TSingleState = TSingleState;